import React, { useEffect, useRef, useState } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";

import { useApi, useUser } from "../../../context/api.js";

function NewClassDialog() {
  const user = useUser();
  const api = useApi();
  const currentYear = parseInt(user.year);
  const timers = useRef();

  // School
  const [schoolLoading, setSchoolLoading] = useState(false);
  const [schoolChoices, setSchoolChoices] = useState([]);
  const [school, setSchool] = React.useState(null);
  const [schoolInput, setSchoolInput] = React.useState("");

  const searchSchool = (event, newInputValue, reason) => {
    setSchoolInput(newInputValue);

    if (reason === "input") {
      setSchoolLoading(true);

      if (timers.schoolSearch) {
        clearTimeout(timers.schoolSearch);
      }

      timers.schoolSearch = setTimeout(() => {
        api.getSchools(newInputValue).then((schools) => {
          setSchoolChoices(schools.map((s) => ({ id: s.id, label: s.name })));
          setSchoolLoading(false);
        });
      }, 500);
    }
  };

  // class
  const [classLoading, setClassLoading] = useState(false);
  const [classChoices, setClassChoices] = useState([]);
  const [selectedClass, setSelectedClass] = React.useState(null);
  const [classInput, setClassInput] = React.useState("");

  const searchClass = (event, newInputValue, reason) => {
    setClassInput(newInputValue);

    if (reason === "input") {
      setClassLoading(true);

      if (timers.classSearch) {
        clearTimeout(timers.classSearch);
      }

      timers.classSearch = setTimeout(() => {
        api.getClasses(school.id, newInputValue).then((classes) => {
          setClassChoices(classes.map((s) => ({ id: s.id, label: s.name })));
          setClassLoading(false);
        });
      }, 500);
    }
  };

  useEffect(() => {
    if (school && school.id) {
      searchClass(null, "", "input");
    }
  }, [school && school.id]);

  const handleSubmit = () => {
    if (selectedClass && selectedClass.id) {
      api.setUserClass(selectedClass.id).then((res) => {
        if (res) {
          api.reloadProfile();
        }
      });
    }
  };

  return (
    <Dialog open={user.type === "student" && !user.class_name}>
      <DialogTitle>Bienvenue dans cette nouvelle année !</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Nous allons maintenant sélectionner ta nouvelle classe pour cette année{" "}
          <b>
            {currentYear}-{currentYear + 1}
          </b>
          .
        </DialogContentText>
        <Autocomplete
          disableClearable
          id="school-name"
          value={school}
          onChange={(event, newValue) => {
            setSchool(newValue);
          }}
          inputValue={schoolInput}
          onInputChange={searchSchool}
          options={schoolChoices}
          loading={schoolLoading}
          loadingText="Recherche..."
          noOptionsText={
            schoolInput && !schoolLoading
              ? "Pas de résultat."
              : "Saisissez quelques caractères pour rechercher une école."
          }
          fullWidth
          sx={{ mt: 1 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="École"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {schoolLoading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
        <Autocomplete
          disabled={!school}
          disableClearable
          id="class-name"
          value={selectedClass}
          onChange={(event, newValue) => {
            setSelectedClass(newValue);
          }}
          inputValue={classInput}
          onInputChange={searchClass}
          options={classChoices}
          loading={classLoading}
          loadingText="Recherche..."
          noOptionsText={
            classInput && !classLoading
              ? "Pas de résultat."
              : "Saisissez quelques caractères pour rechercher une classe."
          }
          fullWidth
          sx={{ mt: 1 }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Classe"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {schoolLoading ? <CircularProgress color="inherit" size={20} /> : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={!selectedClass || !selectedClass.id} onClick={handleSubmit}>
          Valider
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NewClassDialog;
